{
  "name": "bet-plus-web",
  "version": "4.0.8-39",
  "scripts": {
    "analyze": "npm run dev-analyze && npx source-map-explorer \"dist/bet-plus-web/browser/**/*.js\"",
    "ng": "ng",
    "compodoc": "npx compodoc -p tsconfig.doc.json --disableRoutesGraph",
    "start": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng serve  --host 0.0.0.0",
    "start-no-live-reload": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng serve --no-live-reload",
    "generate-build-info": "node scripts/generate-build-info.mjs",
    "build": "node scripts/generate-build-info.mjs && node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build && node scripts/generate-build-info.mjs --dist-only",
    "build-dev": "node scripts/generate-build-info.mjs && node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration development && node scripts/generate-build-info.mjs --dist-only",
    "dev": "node scripts/generate-build-info.mjs && node --max_old_space_size=30000 ./node_modules/@angular/cli/bin/ng build --configuration dev && node scripts/generate-build-info.mjs --dist-only",
    "qa": "node scripts/generate-build-info.mjs && node --max_old_space_size=30000 ./node_modules/@angular/cli/bin/ng build --configuration qa && node scripts/generate-build-info.mjs --dist-only",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:ci": "jest --ci",
    "test:coverage": "jest --coverage",
    "lint": "eslint . --ext .ts,.html",
    "lint:fix": "eslint . --ext .ts,.html --fix",
    "dev-analyze": "node scripts/generate-build-info.mjs && node --max_old_space_size=30000 ./node_modules/@angular/cli/bin/ng build --configuration dev && node scripts/generate-build-info.mjs --dist-only",
    "esAnalizer": "node scripts/esbuild-analyze.mjs",
    "e2e": "ng e2e",
    "start:ssl": "ng serve --host 0.0.0.0 --ssl true --ssl-cert './localhost+2.pem' --ssl-key './localhost+2-key.pem'",
    "local": "ng serve --port 8080 --host 0.0.0.0 --disable-host-check true",
    "deploy-backoffice-dev": "sh scripts/deploy-backoffice-dev.sh",
    "deploy-backoffice-prd": "sh scripts/deploy-backoffice-prd.sh",
    "pre-commit": "lint-staged --no-stash true",
    "prepare": "husky install",
    "no-unused-file": "node check-unused-warning.js"
  },
  "private": true,
  "pre-commit": [
    "lint",
    "circular-dependency-scan",
    "node ./scripts/check-unused-warning.js"
  ],
  "dependencies": {
    "@ag-grid-community/locale": "35.0.0",
    "@angular/animations": "^20.3.9",
    "@angular/cdk": "^20.2.11",
    "@angular/common": "^20.3.9",
    "@angular/compiler": "^20.3.9",
    "@angular/core": "^20.3.9",
    "@angular/forms": "^20.3.9",
    "@angular/material": "^20.2.11",
    "@angular/material-moment-adapter": "^20.2.11",
    "@angular/platform-browser": "^20.3.9",
    "@angular/platform-browser-dynamic": "^20.3.9",
    "@angular/router": "^20.3.9",
    "@angular/service-worker": "^20.3.9",
    "@babel/runtime": "^7.28.4",
    "@ctrl/tinycolor": "^4.0.3",
    "@danielmoncada/angular-datetime-picker": "20.0.0",
    "@iharbeck/ngx-virtual-scroller": "15.2.0",
    "@jsquash/avif": "^2.1.1",
    "@jsquash/png": "^3.1.1",
    "@jsquash/webp": "^1.5.0",
    "@lottiefiles/dotlottie-web": "^0.74.0",
    "@mendeldantas/ng-datatable": "0.1.8",
    "@ngbracket/ngx-layout": "17.0.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "16.0.1",
    "@rx-angular/cdk": "15.0.0",
    "@rx-angular/template": "15.2.0",
    "@swimlane/ngx-charts": "20.5.0",
    "@tweenjs/tween.js": "^21.0.0",
    "@types/crypto-js": "^4.2.2",
    "@types/file-saver": "^2.0.5",
    "@types/jszip": "^3.4.0",
    "ag-charts-enterprise": "13.0.0",
    "ag-grid-angular": "35.0.0",
    "ag-grid-community": "35.0.0",
    "ag-grid-enterprise": "35.0.0",
    "angular-gridster2": "^15.0.0",
    "angular2-chartjs": "^0.5.1",
    "angularx-qrcode": "15.0.1",
    "apexcharts": "^3.49.0",
    "chart.js": "4.4.1",
    "chartjs-plugin-datalabels": "2.2.0",
    "cronstrue": "^2.50.0",
    "crypto-js": "^4.2.0",
    "dayjs": "^1.11.13",
    "file-saver": "^2.0.5",
    "fuse.js": "^7.1.0",
    "html2pdf.js": "https://github.com/eKoopmans/html2pdf.js#bugfix/clone-nodes-BUILD",
    "jszip": "^3.10.1",
    "libphonenumber-js": "^1.11.4",
    "lodash-es": "^4.17.21",
    "moment": "^2.29.1",
    "monaco-editor": "^0.52.2",
    "ng-apexcharts": "1.7.7",
    "ng-lazyload-image": "^9.1.3",
    "ng-recaptcha": "^11.0.0",
    "ng2-charts": "4.1.1",
    "ngx-color-picker": "13",
    "ngx-drag-scroll": "15.0.0",
    "ngx-infinite-scroll": "15.0.0",
    "ngx-lottie": "^21.2.0",
    "ngx-mask": "15.2.3",
    "ngx-mat-intl-tel-input": "^5.0.0",
    "ngx-print": "^1.3.1",
    "ngx-print-anzap": "^1.2.0-beta.5",
    "ngx-skeleton-loader": "7.0.0",
    "node-cpf": "^1.1.1",
    "nxt-json-view": "14.0.0",
    "randexp": "^0.5.3",
    "rxjs": "^7.5.0",
    "swiper": "12.1.3",
    "tslib": "^2.0.0",
    "vanilla-text-mask": "^5.1.1",
    "workbox-cli": "^7.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.8",
    "@angular-eslint/builder": "19.1.0",
    "@angular-eslint/eslint-plugin": "19.1.0",
    "@angular-eslint/eslint-plugin-template": "19.1.0",
    "@angular-eslint/schematics": "19.1.0",
    "@angular-eslint/template-parser": "19.1.0",
    "@angular/cli": "^20.3.8",
    "@angular/compiler-cli": "^20.3.9",
    "@angular/language-service": "^20.3.9",
    "@commitlint/cli": "^17.8.1",
    "@commitlint/config-conventional": "^17.8.1",
    "@compodoc/compodoc": "^1.1.26",
    "@types/emscripten": "^1.41.5",
    "@types/jest": "^30.0.0",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "autoprefixer": "^10.4.23",
    "codelyzer": "^6.0.0",
    "commitlint-plugin-function-rules": "^2.0.2",
    "esbuild": "^0.27.3",
    "eslint": "8.57.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.6.3",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "husky": "^8.0.3",
    "jest": "^30.3.0",
    "jest-environment-jsdom": "^30.3.0",
    "jest-preset-angular": "^16.1.4",
    "lint-staged": "^13.3.0",
    "ngx-clipboard": "^15.1.0",
    "postcss": "^8.5.6",
    "prettier": "^3.5.2",
    "protractor": "~7.0.0",
    "tailwindcss": "^3.4.19",
    "ts-node": "~7.0.0",
    "typescript": "~5.8.3",
    "validate-branch-name": "^1.3.0",
    "workbox-build": "^7.3.0"
  },
  "lint-staged": {
    "src/**/*.{json,md,html,css,scss}": [
      "prettier --write"
    ],
    "*.ts": [
      "prettier --write",
      "tslint --fix"
    ]
  },
  "validate-branch-name": {
    "pattern": "^(master|develop){1}$|^(feature|feat|fix|bug|docs|improvement|improve)/[0-9]{1,}[-][a-zA-Z0-9-]+$",
    "errorMsg": "Branch name invalid. Valid branch Ex: fix/043-FeatureDescription"
  }
}
